import { axiosPrivate } from "@/lib/axios/axios-private";
import { apiErrorFromEnvelope, ApiError } from "@/lib/api/errors";
import type { AuthApiUser, MeEnvelope } from "@/types/auth-api-types";

export async function fetchCurrentUser(): Promise<AuthApiUser> {
  const { data: envelope } = await axiosPrivate.get<MeEnvelope>("/api/me");

  if (!envelope.success || envelope.code !== 200) {
    throw apiErrorFromEnvelope(envelope, "user-profile");
  }

  if (!envelope.data) {
    throw new ApiError(
      "Your account information could not be loaded. Please sign in again.",
      envelope.code,
    );
  }

  return envelope.data;
}
